export default function getAges(range: "from" | "to", selectedOpposed: any) {
  const optionsFrom = [13, 18, 25, 35, 46];
  const optionsTo = [17, 24, 34, 45, 65];
  const options = range === "from" ? optionsFrom : optionsTo;

  return options.map((item) => {
    return {
      value: item,
      label: item,
      isDisabled:
        range === "from" && selectedOpposed
          ? item >= selectedOpposed?.value
          : item <= selectedOpposed?.value,
    };
  });
}
